module.exports = __webpack_public_path__ + "img/s-awc.f3393372.png";